import * as React from 'react';
import * as cn from 'classnames';
import { Link } from 'react-router-dom';
import { Popover } from '@mq/aurora-components/dist/popover';

import * as styles from './footer.css';
import * as grid from '../../styles/grid.css';
import { LogoGoldman } from '../logos/logo-goldman';
const logo = require('../../assets/svg/gs-black.svg') as string;

const NavigationItems = [{ title: 'Careers', url: '/careers' }];

interface IFooterProps {
  background?: string;
}

export const Footer: React.SFC<IFooterProps> = props => {
  const background = props.background ? props.background : '#F5F6FA';

  const content: JSX.Element = (
    <div className={styles.footerMenu}>
      <h5>Marquee Help</h5>
      <div className={styles.item}>
        <h6>US &amp; Canada</h6>
        <p>
          <a href="tel:1-855-627-7830">1.855.627.7830</a>
        </p>
      </div>
      <div className={styles.item}>
        <h6>Europe &amp; Africa</h6>
        <p>
          <a href="tel:44-20-7051-7999">44.20.7051.7999</a>
        </p>
      </div>
      <div className={styles.item}>
        <h6>Asia</h6>
        <p>
          <a href="tel:65-6889-3079">65.6889.3079</a>
        </p>
      </div>
      <div className={styles.menuFooter}>
        <p>Or email us at</p>
        <a href="mailto:gs-marquee-help@gs.com">gs-marquee-help@gs.com</a>
      </div>
    </div>
  );

  return (
    <div className={styles.footer} style={{ background }}>
      <div className={cn(grid.container, styles.container)}>
        <div>
          <a target="_blank" href="https://www.gs.com" style={{ width: '72px' }}>
            <LogoGoldman className={styles.footerLogo} color="#313132" />
          </a>
        </div>

        <div>
          <ul className={styles.footerNavigation}>
            {NavigationItems.map(i => (
              <li key={i.title} className={styles.footerNavigationItem}>
                <Link to={i.url}>{i.title}</Link>
              </li>
            ))}

            <li key="contact" className={styles.footerNavigationItem}>
              <Popover
                content={content}
                hideArrow
                overlayClassName={styles.footerMenu}
                trigger="click"
              >
                <a>Contact Us</a>
              </Popover>
            </li>

            <li key="login" className={styles.footerNavigationItem}>
              <a href="/s">Login</a> {/* we point to /s so that router can handle redirect */}
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.logo}>
        <a href="https://www.gs.com" target="_blank">
          <img src={logo} />
        </a>
      </div>
    </div>
  );
};
